import { render, staticRenderFns } from "./ModalEditTeacher.vue?vue&type=template&id=0342740b&scoped=true&lang=pug&"
import script from "./ModalEditTeacher.vue?vue&type=script&lang=ts&"
export * from "./ModalEditTeacher.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0342740b",
  null
  
)

export default component.exports